<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">CNA Box</a></li>
                            <li>Curso</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Curso</b></h2>
                    </div>
                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="nome">Nome</label>
                                    <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="filter.nome"  />
                                </div>
								<div class="form-group col-md-6">
                                    <label for="iomaId">Idioma</label>
                                    <select v-select="{ dataitem: 'Idioma', default: 'Selecione' }" v-model="filter.iomaId" class="form-control" name="iomaId" ></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="ordem">Ordem</label>
                                    <input type="text" class="form-control" name="ordem" placeholder="Ordem" v-model="filter.ordem"  />
                                </div>

                                <div class="form-group col-md-3">
                                    <label>Sistema</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="sistema" v-model="filter.sistema" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="sistema" v-model="filter.sistema" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="sistema" v-model="filter.sistema" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-3">
                                    <label>Ativo</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>
                               
                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Id<i @click="executeOrderBy('CursoId')" class="fa fa-sort"></i></th>
                                    <th>Nome<i @click="executeOrderBy('Nome')" class="fa fa-sort"></i></th>
                                    <th>Sistema<i @click="executeOrderBy('Sistema')" class="fa fa-sort"></i></th>
                                    <th>Ativo<i @click="executeOrderBy('Ativo')" class="fa fa-sort"></i></th>
                                    <th>Ordem<i @click="executeOrderBy('Ordem')" class="fa fa-sort"></i></th>

                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.cursoId }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.sistema, 'badge-danger': !item.sistema }">{{item.sistema ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ativo, 'badge-danger': !item.ativo }">{{item.ativo ? 'Sim' : 'Não'}}</span></td>
                                    <td>{{ item.ordem }}</td>

                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar" @click="openEdit({ cursoId: item.cursoId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Remover" @click="openRemove({ cursoId: item.cursoId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>
		
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="cursoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    
    export default {
        name: 'curso',
        mixins: [base],
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'curso',
                    remove: 'curso'
                },

				dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.cursoId = model.cursoId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                console.log(" ----- ",field)
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>